<template>
  <div>
    <div class="typeRow">
      <div  :class="trackingType == '1' ? 'typeItemActive':'typeItem'" @click="switchTrackType('1')">
        <pt-icon class="typeIcon" :type="trackingType == '1'  ? 'icon-shoufengchuji':'icon-shoufengchujihui'"></pt-icon>
        <div class="typeText">{{$t('track.trackingType.1')}}</div>
        <div class="activeTypeLine"></div>
      </div>
      <div style="margin-left: 56px" :class="trackingType == '2' ? 'typeItemActive':'typeItem'" @click="switchTrackType('2')">
        <pt-icon class="typeIcon" :type="trackingType == '2' ? 'icon-chuangzaoxuqiu':'icon-chuangzaoxuqiuhui'"></pt-icon>
        <div class="typeText">{{$t('track.trackingType.2')}}</div>
        <div class="activeTypeLine"></div>
      </div>
      <div style="margin-left: 56px" :class="trackingType == '3' ? 'typeItemActive':'typeItem'" @click="switchTrackType('3')">
        <pt-icon class="typeIcon" :type="trackingType == '3' ? 'icon-shibiexuqiu':'icon-shibiexuqiuhui'"></pt-icon>
        <div class="typeText">{{$t('track.trackingType.3')}}</div>
        <div class="activeTypeLine"></div>
      </div>
<!--      <div :class="pursuitsType == '租约重构' ? 'typeItemActive':'typeItem'" @click="switchType('租约重构')">-->
<!--        <pt-icon class="typeIcon" :type="pursuitsType == '租约重构' ? 'icon-zuyuezhonggou3':'icon-zuyuezhonggou-hui'"></pt-icon>-->
<!--        <div class="typeText">{{$t('track.trackType.租约重构')}}</div>-->
<!--        <div class="activeTypeLine"></div>-->
<!--      </div>-->
<!--      <div :class="pursuitsType == '扩租' ? 'typeItemActive':'typeItem'" @click="switchType('扩租')">-->
<!--        <pt-icon class="typeIcon" :type="pursuitsType == '扩租' ? 'icon-kuozu3':'icon-kuozu-hui'"></pt-icon>-->
<!--        <div class="typeText">{{$t('track.trackType.扩租')}}</div>-->
<!--        <div class="activeTypeLine"></div>-->
<!--      </div>-->
      <!--<div :class="pursuitsType == '项目咨询与顾问' ? 'typeItemActive':'typeItem'" @click="switchType('项目咨询与顾问')">-->
      <!--<pt-icon class="typeIcon" :type="pursuitsType == '项目咨询与顾问' ? 'icon-guwenyuzixun':'icon-guwenyuzixun1'"></pt-icon>-->
      <!--<div class="typeText">{{$t('track.trackType.项目咨询与顾问')}}</div>-->
      <!--<div class="activeTypeLine"></div>-->
      <!--</div>-->
      <!--<div :class="pursuitsType == '投资' ? 'typeItemActive':'typeItem'" @click="switchType('投资')">-->
      <!--<pt-icon class="typeIcon" :type="pursuitsType == '投资' ? 'icon-wuyegoumai1':'icon-wuyegoumai2'"></pt-icon>-->
      <!--<div class="typeText">{{$t('track.trackType.投资')}}</div>-->
      <!--<div class="activeTypeLine"></div>-->
      <!--</div>-->
<!--      <div :class="pursuitsType == '其他或无需求' ? 'typeItemActive':'typeItem'" @click="switchType('其他或无需求')">-->
<!--        <pt-icon class="typeIcon" :type="pursuitsType == '其他或无需求' ? 'icon-qita1':'icon-qita-hui'"></pt-icon>-->
<!--        <div class="typeText">{{$t('track.trackType.其他或无需求')}}</div>-->
<!--        <div class="activeTypeLine"></div>-->
<!--      </div>-->
    </div>
    <div class="formDiv">
      <a-form :form="trackForm" layout="vertical">
        <div style="padding: 20px 20px 0 20px;background: rgba(248,249,251,0.62);">
          <a-row :gutter="20">
            <!-- 公司名称 -->
            <a-col :span="16">
              <a-form-item class="required" :label="$t('track.trackModal.companyLabel')">
                <a-select :placeholder="$t('track.trackModal.companyTip')"
                          showSearch
                          :defaultActiveFirstOption='false'
                          :showArrow='false'
                          :filterOption='false'
                          @search='handleSearch'
                          :disabled='leaseVO'
                          @change='customerIdChange'
                          :notFoundContent='null'  v-decorator='decorators.customerId'>
                  <a-icon slot='suffixIcon' type='caret-down' />
                  <div slot='dropdownRender' slot-scope='menu'>
                    <v-nodes :vnodes='menu' />
                    <a-divider style='margin: 0;' />
                    <div class='addCustomerBtn' @click='openAddCustomerModal'>
                      <pt-icon type='icon-zengjia' class='addIcon'></pt-icon>
                      <div style='font-size: 12px;color: #ffffff;margin-left:4px;'>
                        {{ $t('track.trackModal.addCustomer') }}
                      </div>
                    </div>
                  </div>
                  <a-select-option v-for='d in customerList' :key='d.id' :value='d.id'>
                    <div style='display:flex;'>
                      <div style='flex:1;' class='invisible-item'>
                        {{ d.companyName }}
                      </div>
                      <div>
                        {{ d.companySortNameCn }}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 公司简称 -->
            <a-col :span="8">
              <a-form-item class="required" :label="$t('customer.customerModal.companyNameCNLabel')">
                <a-input disabled v-model="companyNameCNLabel" :placeholder="$t('customer.customerModal.companyNameCNTip_2')"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">

            <!-- 需求类型 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.tableLabel.type')">
                <pt-select :placeholder="$t('track.trackModal.choiceTrackType')" v-decorator="decorators.pursuitsType" :allowClear='false' >
                  <a-select-option v-for='d in trackTypes' :key='d.wordKey' :value='d.wordKey' >
                          {{ d.wordValue }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>


            <!-- 需求面积 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.trackModal.needAreaLabel')">
                <a-input-group compact>
                  <pt-input-number style='width:70%;' v-decorator='decorators.demandArea'
                                   :placeholder="$t('track.trackModal.needAreaTip')"
                                   :min='0'
                                   :blackhillsYellow='true'
                                   :max='9999999999' :precision='2'></pt-input-number>
                  <pt-unit-select style='width: 30%;' type='area' v-decorator='decorators.demandAreaUnit'
                                  disabled></pt-unit-select>
                </a-input-group>
              </a-form-item>
            </a-col>

            <!-- 预计启动时间 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.trackModal.expectStartTime')" >
                <pt-month-picker style="width:100%;" v-decorator="decorators.expectStartDate" :placeholder="$t('track.trackModal.expectStartTimeTip')"
                                 :blackhillsYellow="true"></pt-month-picker>
                <!--<a-input-group compact>-->
                <!--<pt-input-number precision="2" style="width:45%;" :placeholder="$t('track.trackModal.orderRentTip')"-->
                <!--:min="0"-->
                <!--v-decorator="decorators.budgetRent" @change="calculateBrokerage" max="99999"></pt-input-number>-->
                <!--<pt-unit-select style="width: 55%;" type="rent" v-decorator="decorators.budgetRentUnit" disabled></pt-unit-select>-->
                <!--</a-input-group>-->
              </a-form-item>
            </a-col>

            <!-- 物业类型 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.trackModal.propertyTypeLabel')">
                <pt-select :placeholder="$t('track.trackModal.propertyTypeTip')" v-decorator='decorators.propertyType'
                           :allowClear='false'>
                  <a-select-option v-for='d in propertyTypes' :key='d.wordKey' :value='d.wordKey'>{{ d.wordValue }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="20">
            <!-- 客户关系 -->
<!--            <a-col :span="8">-->
<!--              <a-form-item :label="$t('track.trackModal.priority')">-->
<!--                <ptSelect :placeholder="$t('track.trackModal.priorityTip')" v-decorator="decorators.priority" :allow-clear="false">-->
<!--                  <a-select-option v-for="c in priorityOptions" :key="c.wordKey" :value="c.wordKey">-->
<!--                    <span class="blackhillsYellow">-->
<!--                      {{c.wordValue}}-->
<!--                    </span>-->
<!--                  </a-select-option>-->
<!--                </ptSelect>-->
<!--              </a-form-item>-->
<!--            </a-col>-->

          </a-row>
          <a-row :gutter="20">
            <!-- 来源途径 -->
<!--            <a-col :span="8">-->
<!--              <a-form-item :label="$t('deal.addDeal.dealSource.sourceType')">-->
<!--                <pt-select v-decorator="decorators.sourceType"-->
<!--                           :placeholder="$t('deal.addDeal.dealSource.errorInfo.sourceType')">-->
<!--                  <a-select-option v-for="d in leaseSourceTypeOptions" :key="d.wordKey" :value="d.wordKey">{{d.wordValue}}</a-select-option>-->
<!--                </pt-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
          </a-row>
          <a-row>
            <!-- 备注 -->
            <a-col :span="24">
              <a-form-item :label="$t('track.trackModal.remarksLabel')">
                <a-textarea  v-decorator="decorators.remarks"
                  :rows="3"
                  :placeholder="$t('track.trackModal.remarksTip')"
                             style="background-color:#FFFFFF !important;"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>

        <!-- 追踪 -->
            <div style="display: flex;flex-direction: row;align-items: center;margin-top: 15px">
              <div style="background-color: #FABE00;width: 12px;height: 12px;border-radius: 50%;"></div>
              <div style="margin-left: 10px;font-size: 14px;font-weight: 600">{{$t('track.trackModal.track')}}</div>
            </div>

        <div style="padding: 20px 20px 0 20px;background: rgba(248,249,251,0.62);margin-top: 5px">

          <a-row :gutter="20">
            <!-- 需求状态 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.tableLabel.demandStatus')" class="required">
                <pt-select style="color: #E9B100" :placeholder="$t('track.queryParams.placeholder.demandStatus')" v-decorator="decorators.demandStatus" :allowClear="false">
                  <a-select-option v-if="item.value != 1"  v-for="(item,index) in $t('track.demandStatus') " :key="index" :value="item.value">{{item.name}}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>

            <!-- 竞争对手 -->
            <a-col :span="16">
              <a-form-item :label="$t('track.trackModal.opponentLabel')">
                <ptSelect mode='multiple' v-model='colleagueList' :placeholder="$t('track.trackModal.opponentTip')"
                          :maxTagCount=3 :maxTagTextLength='6'>
                  <a-select-option v-for='c in competitors' :key='c.id' :value='c.id' :disabled='!c.selectable'>
                    <div style='display:flex;'>
                      <div style='flex:1;' class='invisible-item'>
                        {{ c.companyName }}
                      </div>
                      <div>
                        {{ c.companySortNameCn }}
                      </div>
                    </div>
                  </a-select-option>
                </ptSelect>
              </a-form-item>
            </a-col>


            <!-- 转交易可能性 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.tableLabel.transfer')">
                <div class="slider-wrapper">
                  <pt-slider :edit-mode="!disabled" :old-step="currProjectPossible" @changeStep="changeBrokerageRatio" ref="possibleSliderRef"
                             blackhills-yellow="true" v-decorator="decorators.transfer"></pt-slider>
                </div>
              </a-form-item>
            </a-col>

          <!-- 追踪人员 -->
            <a-col :span="16">
              <a-form-item :label="$t('track.tableLabel.follower')" class="required">
                <pt-user-select
                  :maxTagTextLength="3"
                  v-decorator="decorators.trackPersonDOS"  :placeholder="$t('track.queryParams.placeholder.follower')"  style="width: 150px" mode="multiple" :maxTagCount=3></pt-user-select>
              </a-form-item>
            </a-col>

            <!-- 目标区域 -->
            <a-col :span="24" class="targetClass">
              <a-form-item :label="$t('deal.addDeal.dealDetails.targetArea')">
                <pt-multi-cascader
                  v-decorator="decorators.targetArea"
                  :styleObj="{width: '100%'}"
                  size="small"
                  :options="cityDatas"
                  :props="{multiple: true}"
                  collapse-tags
                ></pt-multi-cascader>
              </a-form-item>
            </a-col>

            <!-- 目标大厦 -->
            <a-col :span="24" >
              <a-form-item  :label="$t('track.tableLabel.targetBuilding')">
                <div @click="openSelectMansion">
                  <pt-select v-decorator="decorators.targetBuilding"
                             :placeholder="$t('track.queryParams.placeholder.targetBuilding')"
                             :defaultActiveFirstOption="false"
                             :showArrow="false"
                             :filterOption="false"
                             :maxTagCount=3 :maxTagTextLength="13"
                             :notFoundContent="null"
                             mode="multiple"
                             @change="mansionChange"
                  >
                    <a-select-option v-for="m in mansionOptions" :key="m.id" :value="m.id">{{ m.name }}
                    </a-select-option>
                  </pt-select>
                </div>
              </a-form-item>
            </a-col>

          </a-row>




        </div>






        <div v-if="pursuitsType != '新设立' && !currentLeaseVisible && leaseInfoDOS.length == 0" @click="toggleCurrentLease(true)">
          <div style="margin-bottom: 5px;margin-left: 20px;">
            <pt-addTag @showButton="showLease" :text="$t('track.trackModal.existingLease')"></pt-addTag>
          </div>
        </div>
        <div v-for='l,index in leaseInfoDOS' class='lease_info'>
          <div class='lease_title'>
            {{ $t('track.trackModal.oldLeaseInfoTitle') }}{{ index + 1 }}
          </div>
          <div @click='showLease(l)'>
            <pt-icon type='icon-bianji1' class='edit_icon'></pt-icon>
          </div>
        </div>
        <div class="expandMoreBtn" v-if="!contactVisible" @click="toggleContact(true)">
          <pt-icon type="icon-zengjia" class="expandIcon"></pt-icon>
          <div class="expandMoreText">{{$t('track.trackModal.contactLabel')}}</div>
        </div>
        <div class="expandDiv" v-if="contactVisible">
          <div class="expandTitleRow">
            <div class="circleYellow"></div>
            <div class="expandTitle">{{$t('track.trackModal.contactLabel')}}</div>
          </div>

          <div class="expandMoreDiv">
            <div class="closeExpandBtn" @click="toggleContact(false)">
              <pt-icon type="icon-guanbi-copy" class="closeIcon"></pt-icon>
            </div>
            <a-form :form="contactForm"  layout="vertical">
              <a-row v-for="(item,index) in contactForms" :key="index">
                <a-col :span="5">
                  <a-form-item :label="index == 0 ? $t('track.trackModal.contactNameLabel') : ''" class="required">
                    <pt-input :placeholder="$t('track.trackModal.contactNameTip')"
                              v-decorator="[`linkmanDOS[${index}].name`,{rules: [
                {required: true,message: $t('linkman.modal.nameCNTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="5" :offset="1">
                  <a-form-item :label="index == 0 ? $t('track.trackModal.positionLabel') : ''">
                    <a-input :placeholder="$t('track.trackModal.positionTip')"
                             v-decorator="[`linkmanDOS[${index}].job`,{rules: [
                // {required: true,message: $t('linkman.modal.jobTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="5" :offset="1">
                  <a-form-item :label="index == 0 ? $t('track.trackModal.contactNum') : ''">
                    <a-input :placeholder="$t('track.trackModal.contactNum')"
                             v-decorator="[`linkmanDOS[${index}].phone`,{rules: [
                // {required: true,message: $t('linkman.modal.mobilePhoneTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                {pattern:/(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}/, message:$t('customer.customerModal.phoneErrorTip'), trigger: 'blur'},
                ],}]"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="5" :offset="1">
                  <a-form-item :label="index == 0 ? $t('track.trackModal.contactEmail') : ''">
                    <a-input :placeholder="$t('track.trackModal.contactEmail')"
                             v-decorator="[`linkmanDOS[${index}].email`,{rules: [
                  {
                    type: 'email',
                    message:$t('customer.customerModal.emailErrorTip'),
                  },
                  {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
                ],}]">
                    </a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="1">
                  <div class="deleteBtn" v-if="index !== 0" @click="deleteContactRow(index)">
                    <pt-icon type="icon-tubiao" class="delIcon"></pt-icon>
                  </div>
                </a-col>
              </a-row>

            </a-form>
            <a-row>
              <div class="addBtn" @click="addContactRow">
                <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
              </div>
            </a-row>
          </div>
        </div>



      </a-form>
    </div>


    <pt-modal :title="$t('proprietor.selectMansionModal.title')" :visible="selectModel.visable"
              :loading="selectModel.loading"
              @ok="submitEvent" @cancel="cancelEvent" :width="800">
      <div slot="content">
        <select-mansion :count-num=3 :radio="false" :mansionList="mansionList" ref="selectMansion" @confirmSelect="confirmSelect"></select-mansion>
      </div>
    </pt-modal>




    <pt-modal :title="customerModalTitle" :visible="customerModalVisible"
              @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
    >
      <div slot='content'>
        <add-customer ref='customerModel' v-model='customerModalTitle' @saveSuccess='saveSuccess'></add-customer>
      </div>
    </pt-modal>
    <pt-modal :title="$t('lease.modal.title')" :visible='currentLeaseVisible'
              @ok='saveLease' @cancel='hideLease' :width='800'
    >
      <div slot='content'>
        <add-lease :defaultCustomerId='getCustomerId'
                   :defaultRentUnit='defaultRentUnit' :defaultAreaUnit='defaultAreaUnit' ref='addLeaseRef'
                   :defaultLeaseInfoVO='defaultLeaseInfoVO == null ? defaultLeaseInfoVO : defaultLeaseInfoVO.leaseLeaseInfoVO'></add-lease>
      </div>
    </pt-modal>
    <dealPursuitsTable :customerId='getCustomerId' ref='dealPursuitsTableRef'></dealPursuitsTable>
  </div>
</template>

<script>

  import pursuitsApi from '@/api/mine/pursuit'
  import customerApi from '@/api/mine/customer'
  import selectMansion from '../../../database/proprietor/module/selectMansion'
  import addCustomer from '../../../database/customer/module/addCustomer'
  import addLease from '@/views/database/lease/module/addLease'
  import colleagueApi from '@/api/database/colleague'
  import { getByCompanyIdAndType, unitTypeEnum } from '@/api/manager/unitUse'
  import { findCascadingData, getDatadictChildsByPath } from '@/api/sys/datadict'
  import dealPursuitsTable from '../../deal/dealPursuitsTable'
  import mansionApi from '@/api/database/mansion'
  import { userMixin } from '@/utils/mixin'

  export default {
    name: 'issueTrack',
    components: {
      addCustomer, addLease,dealPursuitsTable,selectMansion,
      VNodes: {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes,
      },
    },
    props: {
      leaseVO:{},
      customerDetailVO: {},
      canEdit:true,
    },
    mixins:[userMixin],
    data(){
      return{
        priorityOptions: [],
        currProjectPossible:0,
        brokerageRatio:0,
        selectModel: {
          visable: false,
          loading: false
        },
        defaultRentUnit:null,
        companyNameCNLabel:null,
        getCustomerId:null,
        defaultAreaUnit:null,
        trackTypes:[],
        cityDatas: [],
        trackingTypes:[],
        demandStatuses:[],
        colleagueList:[],
        mansionList:[],
        mansionOptions:[],
        competitors:[],
        defaultLeaseInfoVO:null,
        contactForms:[],
        leaseSourceTypeOptions:[],
        contactForm:this.$form.createForm(this,{}),
        leaseInfoDOS:[],
        pursuitsType:'新设立',
        trackingType:'1',
        currentLeaseVisible:false,
        contactVisible:false,
        contactList:[1],
        trackForm:this.$form.createForm(this,{}),
        customerModalVisible:false,
        customerModalTitle:'',
        customerObj:{},
        customerList:[],
        propertyTypes:[],
        defaultFormValue:{
          budgetRent:0,
          demandArea:0,
        },
        decorators:{
          propertyType:['propertyType',{rules:[],initialValue:null}],
          pursuitsType:['pursuitsType',{rules:[],initialValue:null}],
          customerId:['customerId',{rules:[{required:true,message:this.$t('track.trackModal.companyTip')}]}],
          customerName: ['customerName', { rules: [{  message: this.$t('track.trackModal.companyTip') }] }],
          remarks:['remarks',{rules:[{max: 256, message: this.$t('track.trackModal.remarkLengthTip'), trigger: 'blur'},],initialValue:null}],
          demandArea:['demandArea',{rules:[],initialValue:null}],
          demandAreaUnit:['demandAreaUnit',{rules:[],initialValue:null}],
          budgetRent:['budgetRent',{rules:[],initialValue:null}],
          budgetRentUnit:['budgetRentUnit',{rules:[],initialValue:null}],
          mansion:['mansion',{rules:[],initialValue:null}],
          floor:['floor',{rules:[],initialValue:null}],
          unitCode:['unitCode',{rules:[],initialValue:null}],
          leaseArea:['leaseArea',{rules:[],initialValue:null}],
          leaseAreaUnit:['leaseAreaUnit',{rules:[],initialValue:null}],
          rent:['rent',{rules:[],initialValue:null}],
          rentUnit:['rentUnit',{rules:[],initialValue:null}],
          startTime:['startTime',{rules:[],initialValue:null}],
          expectStartDate:['expectStartDate',{rules:[],initialValue:undefined}],
          priority:['priority',{rules:[],initialValue:'Column_A'}],
          endTime:['endTime',{rules:[],initialValue:null}],
          sourceType:['sourceType',{rules:[],initialValue:undefined}],
          demandStatus:['demandStatus',{rules:[{required:true,message:this.$t('track.queryParams.placeholder.demandStatus')}],initialValue:undefined}],
          trackPersonDOS:['trackPersonDOS',{rules:[{required:true,message:this.$t('track.queryParams.placeholder.follower')}],initialValue:undefined}],
          transfer:['transfer',{rules:[],initialValue:undefined}],
          targetBuilding:['targetBuilding',{rules:[],initialValue:undefined}],
          targetArea:['targetArea',{rules:[],initialValue:undefined}],
          linkmanDO:{
            name:['name',{}],
            phone:['phone',{}],
            job:['job',{}],
            email:['email',{}]
          },
        }
      }
  },
  mounted() {
    this.init(),
      this.initServiceDealSourceTypes()
    console.log("登录人信息",this.userInfo.accountDO.id)
  },
  watch:{
    'customerDetailVO.id'(){
      this.init()
    }
  },
  methods: {
    initServiceDealSourceTypes() {
      let this_ = this
      getDatadictChildsByPath('system.business_key.deal_source_set').then(res => {
        this_.leaseSourceTypeOptions = res.data.filter(e => {
          return e.wordKey != 'approach' && e.wordKey != 'invited'
        })
        // this_.leaseSourceTypeOptions = res.data;
      })
    },
    calculateBrokerage() {

      },



      changeBrokerageRatio(){
        this.trackForm.setFieldsValue({transfer: this.$refs.possibleSliderRef.currStep})
      },

      submitEvent() {
        this.$refs.selectMansion.confirmSelect()
      },
      cancelEvent() {
        this.selectModel.visable = false
      },
      openSelectMansion() {
        this.selectModel.visable = true
      },

      confirmSelect(mansionList) {
        this.mansionList = mansionList
        this.mansionOptions = []
        let mansionIds = []
        this.mansionList.forEach(item => {
          this.mansionOptions.push({ id: item.id, name: item.name })
          mansionIds.push(item.id)
        })
        this.$nextTick(() => {
          this.trackForm.setFieldsValue({ targetBuilding: mansionIds })
        })
        this.cancelEvent()
      },

      mansionChange(value) {
        console.log('mansionList', this.mansionList)
        console.log('value', value)
        for (var i = 0; i < this.mansionList.length; i++) {
          let indexOf = value.indexOf(this.mansionList[i].id)
          if (indexOf == -1) {
            this.mansionList.splice(i, 1)
            i--
          }
        }
        this.fillMansionOptions()
      },

      queryCityDataByCity() {//根据城市查询区域位置
        findCascadingData('system.mansion_set.address', 4, undefined).then(res => {
          this.cityDatas = res.data
        })
      },

      fillMansionOptions() {
        this.mansionOptions = []
        this.mansionList.forEach(data => {
          let mansionOption = {
            name: data.name,
            id: data.id
          }
          this.mansionOptions.push(mansionOption)
        })
      },

      //获取需求类型
      initTrackType(){
        let trackTypes = this.$t('track.trackTypeMy')
        let label = '新设立'
        for(var p in trackTypes){
          if(this.leaseVO && p == '新设立'){
            label = '搬迁'
          }else{
            this.trackTypes.push({wordKey:p,wordValue:trackTypes['' + p]})
          }
        }
        this.trackForm.setFieldsValue({pursuitsType:label})
      },

      customerIdChange(value){
        this.getCustomerId = value
        let customerDO = this.customerList.find(e=>{ return e.id == value })
        this.companyNameCNLabel = customerDO.companySortNameCn
        this.$refs.dealPursuitsTableRef.queryDealPursuitsList(this.getCustomerId,1)
      },
      handleSearch(customerName){
        setTimeout(()=>{
          let this_ = this
          customerApi.queryByName({name: customerName}).then(res => {
            this_.customerList = res.data
          })
        },300);
      },
    handleSearchById(id) {
      console.log("handleSearchById",id)
      let this_ = this
      customerApi.selectOne(id).then(res => {
        this_.companyNameCNLabel = res.data.companySortNameCn
        this_.trackForm.setFieldsValue({
          customerId: res.data.id,
          customerName: res.data.companyName,
        })
        console.log(this_.trackForm.getFieldsValue())
        // console.log("this_.trackForm.",this_.trackForm.getFieldsValue())
        this_.customerList.push(res.data)
      })
      console.log("customerList",this_.customerList)

    },
      hideLease(){
        this.currentLeaseVisible = false
      },
      init(){

        let trackPersonDOStr = []
        trackPersonDOStr.push(this.userInfo.accountDO.id)
        this.trackForm.setFieldsValue({ trackPersonDOS: trackPersonDOStr })

        if(this.leaseVO){
          this.fillForm();
        }
        if (this.customerDetailVO) {
          this.initMansionOptions()
          this.initCustomerRelationShipOptions()
          this.initFormDefaultValue()
          this.initDefaultAreaUnit()
          this.initDefaultRentUnit()
          this.initCompetitors()
          this.initPropertyTypes()
          this.initTrackType()
          this.queryCityDataByCity()
          console.log('客户详情', this.customerDetailVO)
          this.handleSearchById(this.customerDetailVO.id)
          this.customerIdChange(this.customerDetailVO.id)
        }
        this.initMansionOptions()
        this.initCustomerRelationShipOptions()
        this.initFormDefaultValue()
        this.initDefaultAreaUnit()
        this.initDefaultRentUnit()
        this.initCompetitors()
        this.initPropertyTypes()
        this.initTrackType()
        this.queryCityDataByCity()


      },

      initMansionOptions(value) {
        if (value == null || value == '') {
          return
        }
        mansionApi.listAll({ queryText: value }).then(res => {
          if (res.code == 1) {
            this.mansionOptions = res.data
          }
        })
      },
      fillForm(){
        this.pursuitsType = '搬迁';
        this.customerList = [];
        var customerDO = {
          companyName:this.leaseVO.companyName,
          id:this.leaseVO.customerId,
          companySortNameCn: this.leaseVO.companyShortNameCN
        }
        this.companyNameCNLabel = this.leaseVO.companyShortNameCN
        this.trackForm.setFieldsValue({
          customerId: this.leaseVO.customerId,
          demandArea: this.leaseVO.leaseArea,
          demandAreaUnit: this.leaseVO.leaseAreaUnit,
          budgetRent:this.leaseVO.rent,
          budgetRentUnit:this.leaseVO.rentUnit,
          demandStatus:undefined,
        })
        if(this.leaseVO.colleagueDOS){
          this.leaseVO.colleagueDOS.forEach(c=>{
            this.colleagueList.push(c.id);
          })
        }
        this.customerList.push(customerDO);
        let temp = JSON.stringify(this.leaseVO)
        this.leaseInfoDOS.push({newLease:false, leaseLeaseInfoVO: JSON.parse(temp.replace(/\"~\"/g,null))})
        this.$refs.dealPursuitsTableRef.queryDealPursuitsList(this.leaseVO.customerId,1)
      },
      initCustomerRelationShipOptions(){
        customerApi.getCustomerRelationShipOptions().then(res=>{
          if(res.code == 1){
            this.priorityOptions = res.data
            this.priorityOptions.sort((a,b)=>{
              return a.listIndex - b.listIndex
            })
          }
        })
      },

      //切換追蹤類型
      switchTrackType(data){
        this.trackingType = data
      },

      initCompetitors(){
        colleagueApi.selectAll().then(res=>{
          if(res.code == 1){
            this.competitors = res.data.records
          }
        })
      },
      initFormDefaultValue(){
        this.trackForm.setFieldsValue(this.defaultFormValue)
      },
      initDefaultAreaUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.AREA).then(res=>{
            if(res.code == 1){
              this.defaultAreaUnit = res.data[0]
              this.trackForm.setFieldsValue({demandAreaUnit:res.data[0]})
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initDefaultRentUnit(){
        let p = new Promise((resolve,reject)=>{
          getByCompanyIdAndType(unitTypeEnum.RENT).then(res=>{
            if(res.code == 1){
              this.defaultRentUnit = res.data[0]
              this.trackForm.setFieldsValue({budgetRentUnit:res.data[0]})
              resolve()
            }else{
              reject()
            }
          })
        })
        return p
      },
      initPropertyTypes(){
        let propertyTypes = this.$t('deal.propertyTypes')
        for(var p in propertyTypes){
          this.propertyTypes.push({wordKey:p,wordValue:propertyTypes['' + p]})
          this.trackForm.setFieldsValue({propertyType:'写字楼'})
        }
      },


      switchType(type){
        this.pursuitsType = type;
      },
      toggleCurrentLease(visible){
        this.currentLeaseVisible = visible;
      },
      toggleContact(visible){
        this.contactVisible = visible;
        if(visible){
          this.addContactRow()
        }else{
          this.contactForms = []
        }
      },
      deleteContactRow(index){
        let keys = this.contactForm.getFieldValue('linkmanDOS');
        this.contactForm.setFieldsValue({
          linkmanDOS: keys.filter((item,i) => index !== i),
        })
        this.contactForms.splice(index,1);
      },
      addContactRow(){
        this.contactForms.push({});
      },
      openAddCustomerModal(){
        this.customerModalVisible = true;
      },
      saveCustomer(){
        this.$refs.customerModel.submit();
      },
      saveSuccess(id,name, customer){
        this.customerList = [];
        var customerDO = {
          companyName:name,
          id:id,
          companySortNameCn: customer.companySortNameCn
        }
        this.getCustomerId = id
        this.companyNameCNLabel = customer.companySortNameCn
        this.trackForm.setFieldsValue({
          customerId: id,
        })
        this.customerList.push(customerDO);
        this.customerModalVisible = false;
      },
      saveLease(){
        let leaseInfoVO = this.$refs.addLeaseRef.extractLeaseInfoVO()
        if(!leaseInfoVO){
          return
        }
        if(this.defaultLeaseInfoVO){
          this.leaseInfoDOS[this.leaseInfoDOS.indexOf(this.defaultLeaseInfoVO)] = {newLease:false, leaseLeaseInfoVO: leaseInfoVO}
        }else{
          this.leaseInfoDOS.push({newLease:false, leaseLeaseInfoVO: leaseInfoVO})
        }
        this.hideLease()
      },
      showLease(leaseInfoVO){
        this.currentLeaseVisible = true
        this.defaultLeaseInfoVO = leaseInfoVO
      },
      getData(){
        this.trackForm.validateFieldsAndScroll((err,values) => {
          if(!err){
            this.submitPursuit();
          }else{
            this.$emit('error')
          }
        })
      },
      submitPursuit(){
        let validatePass = true
        let pursuitVO = this.trackForm.getFieldsValue()
        this.contactForm.validateFields(err=>{
          if(err){
            validatePass = false
          }
        })
        if(!validatePass){
          this.$emit('error')
          return
        }
        pursuitVO.linkmanDOS = this.contactForm.getFieldsValue().linkmanDOS
        // pursuitVO.leaseLeaseInfoVOS = this.leaseInfoDOS
        pursuitVO.leaseLeaseInfoTypeVOS = this.leaseInfoDOS
        pursuitVO.trackingType = this.trackingType
        pursuitVO.colleagueDOS = this.colleagueList.map(e=>{
          return {id: e}
        })
        console.log("pursuitVO",pursuitVO)
        pursuitsApi.insert(pursuitVO).then(res=>{
          if(res.code == 1){
            this.$message.success("保存成功")
            this.$emit('saveSuccess')
          }else{
           // this.$message.error(res.message)
            this.$emit('error')
          }
        })
      },
      cancelAddCustomer(){
        this.customerModalVisible = false;
      }
    }
  }
</script>

<style scoped lang='less'>
@import '../../../../core/diy.less';

  .blackhillsYellow{
    color: @blackhills-yellow;
  }

.targetClass /deep/ .el-input__inner {
  padding: 0px 4px !important;
}


  .typeRow{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    position: relative;
    border-bottom: 1px solid #E1E1E1;
    .typeIcon{
      font-size:40px;
    }
    .typeItem{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      /*margin-right: 50px;*/
      cursor: pointer;
      height: 82px;
      .typeText{
        font-size: 12px;
        color: #999999;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .activeTypeLine{
        width: 100%;
        height: 2px;
        background: transparent;
      }
    }
    .typeItem:hover{
      .newsTypeText{
        color: #333333;
      }
    }
    .typeItemActive{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      /*margin-right: 50px;*/
      cursor: pointer;
      height: 82px;
      .typeText{
        font-size: 12px;
        color: #333333;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .activeTypeLine{
        width: 100%;
        height: 2px;
        background: #FABE00;
      }
    }
  }
  .formDiv{
    border-radius: 0 0 4px 4px;
  }

  .divContent{
    background: rgba(248,249,251,0.62);
  }

  .expandMoreBtn{
    margin-top: 12px;
    background: #E8E8E8;
    border: 1px solid #DFDFDF;
    border-radius: 2px;
    height: 25px;
    display: inline-block;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    cursor:pointer;
    margin-bottom: 5px;
    .expandIcon{
      font-size: 12px;
    }
    .expandMoreText{
      display: inline;
      margin-left: 5px;
      font-size: 12px;
      color: #666666;
    }
  }
  .expandDiv{
    margin-bottom: 20px;
    .expandMoreDiv{
      margin: 0 14px;
      padding: 20px 10px 0px 10px;
      background: #F2F4F6;
      border-radius: 2px;
      position: relative;
    }
    .closeExpandBtn{
      position: absolute;
      right: 0px;
      top:0px;
      width: 24px;
      height: 24px;
      border-radius:2px;
      background: #D3D3D3;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      .closeIcon{
        font-size: 14px;
        color: #FFFFFF;
      }
    }

    .expandTitleRow{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 10px;
      margin-bottom: 5px;
      .circleYellow{
        width: 12px;
        height: 12px;
        background: #FABE00;
        border-radius: 50%;
        margin: 0 10px;
      }
      .expandTitle{
        font-size: 14px;
        color: #333333;
      }
    }
  }
  .labelText{
    font-size: 12px;
    color: #999999;
    margin-left: 4px;
  }
  .deleteBtn{
    margin-top: 10px;
    margin-left: 10px;
    cursor: pointer;
    .delIcon{
      font-size: 18px;
    }
  }
  .addBtn{
    width: 20px;
    height: 16px;
    border: 1px solid #FABE00;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-bottom: 18px;
    .addIcon{
      font-size: 12px;
      color: #FABE00;
    }
  }
  .addCustomerBtn{
    background: #3B2E26;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 30px;
    .addIcon{
      color: #ffffff;
      font-size: 12px;
    }
  }
  .lease_info{
    display: flex;
    .lease_title{
      flex: 1;
      font-size: 14px;
      color: #333333;
      font-weight: bold;
    }
    position: relative;
    margin-bottom: 5px;
    background: rgba(248,249,251,0.62);
    padding: 10px 20px;
    .edit_icon{
      font-size: 18px;
    }
  }
  .ant-select-dropdown-content{
    /deep/.invisible-item{
      display:initial !important;
    }
  }
  /deep/.invisible-item{
    display:none;
  }
</style>